import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import { EmptyState, Button, InfoIcon, Flex } from '@buffer-mono/popcorn'

import { Blocker, CTABackground } from '~/shared/components'
import PostDetails from '~/modules/post/components/PostDetails'
import CommentList from '~/modules/post/components/CommentList/CommentList'
import { INBOX_EMPTY_IMG } from '~/app/constants'
import type { Channel } from '~/modules/account/types'

import DismissAllBanner from './DismissAllBanner'
import { Wrapper, BannerWrapper, PostWrapper, Header, Body } from './styles'

const GIVEAWAY_LIMIT_MIN = 3
const GIVEAWAY_LIMIT_MAX = 2000

/**
 *
 */
const PostView = ({
  // @ts-expect-error TS(7031) FIXME: Binding element 'post' implicitly has an 'any' typ... Remove this comment to see the full error message
  post,
  // @ts-expect-error TS(7031) FIXME: Binding element 'fallbackImg' implicitly has an 'a... Remove this comment to see the full error message
  fallbackImg,
  // @ts-expect-error TS(7031) FIXME: Binding element 'disabled' implicitly has an 'any'... Remove this comment to see the full error message
  disabled,
  // @ts-expect-error TS(7031) FIXME: Binding element 'selectedComment' implicitly has a... Remove this comment to see the full error message
  selectedComment,
  // @ts-expect-error TS(7031) FIXME: Binding element 'placeholder' implicitly has an 'a... Remove this comment to see the full error message
  placeholder,
  // @ts-expect-error TS(7031) FIXME: Binding element 'error' implicitly has an 'any' ty... Remove this comment to see the full error message
  error,
  // @ts-expect-error TS(7031) FIXME: Binding element 'onSelectComment' implicitly has a... Remove this comment to see the full error message
  onSelectComment,
  // @ts-expect-error TS(7031) FIXME: Binding element 'onDismissComment' implicitly has ... Remove this comment to see the full error message
  onDismissComment,
  // @ts-expect-error TS(7031) FIXME: Binding element 'onUnDismissComment' implicitly ha... Remove this comment to see the full error message
  onUnDismissComment,
  // @ts-expect-error TS(7031) FIXME: Binding element 'onDismissAll' implicitly has an '... Remove this comment to see the full error message
  onDismissAll,
  // @ts-expect-error TS(7031) FIXME: Binding element 'onAddReply' implicitly has an 'an... Remove this comment to see the full error message
  onAddReply,
  // @ts-expect-error TS(7031) FIXME: Binding element 'onEngageCompleted' implicitly has... Remove this comment to see the full error message
  onEngageCompleted,
  currentChannel,
  accountChannels = [],
}: {
  currentChannel: Channel
  accountChannels: Channel[]
}): JSX.Element => {
  // @ts-expect-error TS(2554) FIXME: Expected 2 arguments, but got 1.
  const onGoToNextPost = useCallback(() => {
    onEngageCompleted()
  })

  // @ts-expect-error TS(2554) FIXME: Expected 2 arguments, but got 1.
  const onTryAgain = useCallback(() => {
    window.location.reload()
  })

  const {
    totalPendingComments = 0,
    comments,
    backfilling = false,
    dismissingAll = false,
  } = post || {}

  const commentsListClassName =
    placeholder || backfilling ? 'loading' : 'loaded'
  const canDismissAll =
    totalPendingComments > GIVEAWAY_LIMIT_MIN &&
    totalPendingComments <= GIVEAWAY_LIMIT_MAX

  const noComments = comments?.length === 0
  const showPostEmpty = post && !error && !placeholder && noComments
  const showDismissAllBanner = canDismissAll && !dismissingAll

  // Engage frontend has an idea of the current channel. However, it queries
  // Engage API, rather than Core API, and merges engage specific channel
  // data with channel data queried from Core API. (MergedChannel).
  // Engage specific queries don't have the apiVersion available,
  // so this workaround uses the 'currentChannel' from Engage and finds the
  // account channel with the apiVersion that we can use for Instagram.
  const currentEngageChannel = accountChannels.find(
    (channel: Channel) => channel?.id === currentChannel?.id,
  )

  const isInstagramLoginChannel =
    currentEngageChannel?.service === 'instagram' &&
    currentEngageChannel?.apiVersion === 'instagramLogin'

  if (isInstagramLoginChannel) {
    return (
      <Wrapper>
        <PostWrapper className="empty-state">
          <EmptyState size="medium" variant="primary">
            <EmptyState.Icon>
              <InfoIcon />
            </EmptyState.Icon>
            <EmptyState.Heading>
              Unlock Instagram Engagement for {currentChannel?.name}
            </EmptyState.Heading>
            <EmptyState.Description>
              To access your comments and let you reply to others, link your
              Instagram to a Facebook Page.
            </EmptyState.Description>
            <EmptyState.Actions>
              <Flex direction="column" gap="sm" align="center">
                <Button
                  onClick={(): void => {
                    const { MODALS, actions } = window?.appshell || {}
                    actions.openModal(MODALS.instagramFacebookReAuth, {
                      channelId: currentEngageChannel?.id,
                    })
                  }}
                >
                  Show Me How
                </Button>
                <Button
                  variant="tertiary"
                  onClick={(): void => {
                    window.location.assign(
                      'https://support.buffer.com/article/568-connecting-your-instagram-business-or-creator-account-to-buffer#Converting-and-linking-your-Instagram-account-to-a-Facebook-Page--TLG6Z?utm_source=buffer&utm_medium=learn-more-link&utm_campaign=learn-more',
                    )
                  }}
                >
                  Learn More
                </Button>
              </Flex>
            </EmptyState.Actions>
          </EmptyState>
        </PostWrapper>
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      {showDismissAllBanner && (
        <BannerWrapper>
          <DismissAllBanner
            message="There's a lot of activity. Would you like to dismiss all comments?"
            onDismissAll={onDismissAll}
          />
        </BannerWrapper>
      )}
      <PostWrapper>
        <Header>
          <PostDetails
            post={post}
            // @ts-expect-error TS(2322) FIXME: Type '{ post: any; fallbackImg: any; animated: any... Remove this comment to see the full error message
            fallbackImg={fallbackImg}
            animated={placeholder}
          />
        </Header>
        <Body id="comments-list" className={commentsListClassName}>
          {showPostEmpty && (
            <CTABackground
              image={INBOX_EMPTY_IMG}
              title="There are no comments on this post yet"
              continueLabel="Engage With Next Post"
              onContinue={onGoToNextPost}
            ></CTABackground>
          )}

          {error && (
            <CTABackground
              title="Whoops! The post could not be loaded!"
              continueLabel="Try Again"
              onContinue={onTryAgain}
            ></CTABackground>
          )}

          {!showPostEmpty && !error && (
            <CommentList
              placeholder={placeholder}
              comments={comments}
              selected={selectedComment}
              onSelect={onSelectComment}
              onAddReply={onAddReply}
              onDismiss={onDismissComment}
              onUnDismiss={onUnDismissComment}
            />
          )}

          {dismissingAll && !disabled && <Blocker />}
        </Body>
      </PostWrapper>
      {disabled && <Blocker />}
    </Wrapper>
  )
}

PostView.propTypes = {
  post: PropTypes.object,
  fallbackImg: PropTypes.string,
  disabled: PropTypes.bool,
  selectedComment: PropTypes.object,
  placeholder: PropTypes.bool,
  error: PropTypes.bool,
  onSelectComment: PropTypes.func.isRequired,
  onDismissComment: PropTypes.func.isRequired,
  onUnDismissComment: PropTypes.func.isRequired,
  onDismissAll: PropTypes.func.isRequired,
  onAddReply: PropTypes.func.isRequired,
  onEngageCompleted: PropTypes.func.isRequired,
}

PostView.defaultProps = {
  post: null,
  fallbackImg: null,
  disabled: false,
  selectedComment: null,
  placeholder: false,
  error: false,
}

export default PostView
